var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportExcelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10193",
    "data-name": "Group 10193",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3957",
    "data-name": "Path 3957",
    d: "M0,0H19V19H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3958",
    "data-name": "Path 3958",
    d: "M2.68,2.5l9.951-1.421a.4.4,0,0,1,.452.392v16.5a.4.4,0,0,1-.451.392L2.679,16.947A.792.792,0,0,1,2,16.163V3.286a.792.792,0,0,1,.68-.784Zm.9,1.471v11.5L11.5,16.607V2.842ZM13.875,15.266H16.25V4.183H13.875V2.6h3.167a.792.792,0,0,1,.792.792V16.058a.792.792,0,0,1-.792.792H13.875ZM8.491,9.724l2.217,3.167h-1.9l-1.267-1.81-1.267,1.81h-1.9L6.591,9.724,4.375,6.558h1.9l1.267,1.81,1.267-1.81h1.9Z",
    transform: "translate(-0.416 -0.224)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportExcelIcon);
export default __webpack_public_path__ + "static/media/ImportExcelIcon.15eeaa0fd74973ac5e3862a55b44134a.svg";
export { ForwardRef as ReactComponent };